module.exports = __webpack_public_path__ + "static/media/help.223d4244.svg";